import axios from '../../axios'

/**
 * todo 获取用户信息
 * @param {code: 123123, openID: owHN-uOygnnR5P5qOmT5IhLp3H4k}
 */
export function getLoginUser(params) {
  return axios.get(`/user/getLoginUser`, params)
}

/**
 * todo 微信分享配置
 * @param {url: 当前分享页面url}
 */
export function getWxConfig(params) {
  return axios.get(`/weixin/getWxConfig`, params)
}

/**
 * todo 支付完成确认
 * @param {tno: 订单id}
 */
export function validatorPayResult(params) {
  return axios.get(`/weixin/validatorPayResult`, params)
}

/**
 * todo 订单列表页点击支付调用
 * @param {tno: 订单id}
 */
export function advancePayOrder(params) {
  return axios.get(`/weixin/advancePayOrder`, params)
}

/**
 * todo 验证用户是否关注
 * @param {}
 */
export function checkUserSubscribe(params) {
  return axios.get(`/user/checkUserSubscribe`, params)
}
